import CryptoJS from "crypto-js";

export const cryptoPassword = (p) => {
  var _obj = { password: "" };
  _obj.password = CryptoJS.SHA3(p, { outputLength: 256 }).toString();
  return _obj.password;
};
